import React, { FC } from "react";
import { Container } from "../../../../components";
import { Heading } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import { CART_ITEM_TYPE, DELIVERY_TYPE, DeliveryType } from "../../../../../../constants";
import { RootState, DeliveryMethod } from "../../../../../../models";
import { PickupPoint } from "../../../../../../models/state";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { getPickupPointPoints } from "../../../../pickup-points/state/selectors";
import { getAllItemsOfType } from "../../../state/selectors/cartSelectors";
import { setSelectedDeliveryType } from "../../../state/actions/combinedActions";
import { setDeliveryNote } from "../../../state/actions/deliveryInfoActions";
import * as CHECKOUT_AT from "../../../state/actionTypes";
import {
    getDeliveryInfoMethods,
    getDeliveryInfoNote,
    getDeliveryInfoType,
} from "../../../state/selectors/deliveryInfoSelectors";
import TEXT from "../../../text-consts";
import DeliveryMethods from "../../molecules/DeliveryMethods/DeliveryMethods";

interface DeliveryCardProps {
    deliveryMethods: DeliveryMethod[];
    hasMobilpant: boolean;
    isLoading: boolean;
    pickupPoints: PickupPoint[];
    selectedNote?: string;
    selectedType?: DeliveryType;
}

const DeliveryCard: FC<DeliveryCardProps> = ({
    isLoading,
    hasMobilpant,
    deliveryMethods,
    selectedType,
    selectedNote,
    pickupPoints,
}) => {
    const dispatch = useDispatch();
    return (
        <Container
            className="summary-container__section"
            size="small"
            whiteBg
            noPaddingTop
            noMargin
            data-cy="delivery-card"
        >
            <Heading mb="100" as="h2" mt="150" variant="title-200">{`${TEXT.DELIVERY.HEADING}:`}</Heading>
            <DeliveryMethods
                isDisabled={isLoading}
                disabledTypes={
                    hasMobilpant
                        ? {
                              [DELIVERY_TYPE.PICK_UP_IN_SHOP]:
                                  "Klikk & Hent er ikke tilgjengelig med mobilpant. Velg en av leveringsmetodene over.",
                          }
                        : undefined
                }
                methods={deliveryMethods}
                selectedType={selectedType}
                selectedNote={selectedNote}
                pickupPoints={pickupPoints}
                onChange={({ deliveryType, code, zipCode }) =>
                    dispatch(setSelectedDeliveryType({ deliveryType, code, zipCode }))
                }
                onNoteChange={(e) => dispatch(setDeliveryNote(e))}
            />
        </Container>
    );
};

const mapStateToProps: (state: RootState) => DeliveryCardProps = (state) => ({
    isLoading:
        LOADING_SELECTORS.isTypeLoading(state, CHECKOUT_AT.CHECKOUT_PAYMENT) ||
        LOADING_SELECTORS.isTypeLoading(state, CHECKOUT_AT.CHECKOUT_SET_DELIVERY_TYPE),
    hasMobilpant: getAllItemsOfType(state, CART_ITEM_TYPE.MOBILE_REFUND).length > 0,
    deliveryMethods: getDeliveryInfoMethods(state),
    selectedType: getDeliveryInfoType(state),
    selectedNote: getDeliveryInfoNote(state),
    pickupPoints: getPickupPointPoints(state),
});

export default connect(mapStateToProps)(DeliveryCard);
